/* eslint-disable @typescript-eslint/no-unused-vars */
import createActions from '../../config/actions/createActions';
import { action } from '@play-co/replicant';
import { magicLampsPlayRound } from './magiclamps.modifiers';

/** Development mode only, not allowed in production  */
export const match2MagicLampsCheats = createActions({
  /**
   * Clear all magicLamps data
   */
  cheat_magicLampsReset: action((state, args: void, _api) => {
    delete state.match2.magicLamps;
  }),
  /**
   * Clear all magicLamps data
   */
  cheat_magicLampsGoToRound: action((state, args: { round: number }, api) => {
    if (!state.match2.magicLamps) return;

    // Play all rounds up to the selected level
    while (state.match2.magicLamps.round < args.round) {
      const result = magicLampsPlayRound(state, api.date.now());
      if (result?.trap) state.match2.magicLamps.continuing = true;
    }
  }),
});
